import $ from 'jquery'
import 'owl.carousel'
import 'sticky-js'

import '../../../../node_modules/owl.carousel/dist/assets/owl.carousel.min.css'
import '../../../../node_modules/owl.carousel/dist/assets/owl.theme.default.min.css'

// import {current_lang_short, apexcharts_lang_file, current_lang} from '../../modules/common.js'


$(window).scroll(function () {
    50 <= $(window).scrollTop() ? $(".sticky").addClass("nav-sticky") : $(".sticky").removeClass("nav-sticky")
});

// Smooth scrolling for in-page anchor links taking into account fixed navigation
$(document).on('click', 'a[href*="#"]', function (e) {
    var href = $(this).attr('href');
    if (!href || href === '#' || href.startsWith('#!')) return;

    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var path = href.substring(0, hashIndex);
    var hash = href.substring(hashIndex);

    var currentPath = window.location.pathname;
    var isCurrentPage = (path === '' || path === currentPath || path.replace(/\/$/, '') === currentPath.replace(/\/$/, ''));

    if (!isCurrentPage) return;

    var $target = $(hash);
    if ($target.length) {
        e.preventDefault();
        var navHeight = $('.navigation').outerHeight() || 70;
        var targetOffset = $target.offset().top - navHeight - 20;

        $('#topnav-menu a').removeClass('active');
        $('#topnav-menu a[href="' + hash + '"], #topnav-menu a[href$="' + hash + '"]').addClass('active');

        $('html, body').stop().animate({
            scrollTop: Math.max(0, targetOffset)
        }, 300, function () {
            if (history.pushState) {
                history.pushState(null, null, hash);
            }
        });
    }
});

// Initial load hash offset correction
if (window.location.hash) {
    $(function () {
        setTimeout(function () {
            var $hashTarget = $(window.location.hash);
            if ($hashTarget.length) {
                var navHeight = $('.navigation').outerHeight() || 70;
                var targetOffset = $hashTarget.offset().top - navHeight - 20;
                $('html, body').scrollTop(Math.max(0, targetOffset));
            }
        }, 100);
    });
}

// Scroll to top button
$("#scrollToTop").on("click", function () {
    $("html, body").stop(true).animate({ scrollTop: 0 }, 250);
});

$(window).on("scroll", function () {
    $(window).height() < $(window).scrollTop() ? $("#scrollToTop").show() : $("#scrollToTop").hide();
});


$("#timeline-carousel").owlCarousel({
    items: 1,
    loop: !1,
    margin: 0,
    nav: !0,
    navText: ["<i class='mdi mdi-chevron-left'></i>", "<i class='mdi mdi-chevron-right'></i>"],
    dots: !1,
    responsive: {
        576: {
            items: 2
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        }
    }
});


// $("#clients-carousel, #team-carousel").owlCarousel({
//     items: 1,
//     loop: !1,
//     margin: 24,
//     nav: !1,
//     dots: !1,
//     responsive: {
//         576: {
//             items: 2
//         },
//         768: {
//             items: 3
//         },
//         992: {
//             items: 4
//         }
//     }
// });